import React from "react"
import { FaCheckCircle } from "react-icons/fa"

import * as ShopButtonStyles from "./shop/shopButton.module.css"
import * as AddToCartButtonStyles from "./addToCartButton.module.css"
import { LanguageContext } from "../utils/LanguageContext"

function getButtonText(sold_out, loading, language) {
  if (sold_out) {
    return language === 'Spanish' ? 'Agotado' : 'Sold out'
  }
  if (!loading) {
    return language === 'Spanish' ? 'Añadir a cesta' : 'Add to basket'
  }
  return " "
}

const AddToCartButton = ({ loading, confirmAddToCart, sold_out }) => {
  return (
    <button
      className={[
        ShopButtonStyles.shopButton,
        confirmAddToCart ? AddToCartButtonStyles.confirmAddToCart : "",
      ].join(" ")}
      disabled={loading || sold_out}
      type="submit"
    >
      <span className={AddToCartButtonStyles.faCheckCircle}>
        <FaCheckCircle />
        ADDED
      </span>
      <LanguageContext.Consumer>
        {({ language }) => getButtonText(sold_out, loading, language)}
      </LanguageContext.Consumer>
    </button>
  )
}

export default AddToCartButton
